module.exports = __webpack_public_path__ + "static/media/coindesk.3a4623a1.png";